import { mapState, mapGetters, mapActions } from 'vuex'

import gaMixin from '@/mixins/ga'
import Icon from '@/components/icon'
import ImgWatermark from '@/components/imgWatermark/imgWatermark'

export default {
  mixins: [gaMixin],
  components: {
    appIcon: Icon,
    appImgWatermark: ImgWatermark
  },
  props: {
    limit: {
      default: 0,
      type: Number
    }
  },
  computed: {
    ...mapState('tours', ['photos']),
    ...mapGetters('tours', ['getPhotosByLimit', 'getUnpaid', 'getPhotos']),
    images () {
      if (this.limit > 0) {
        // return this.getPhotosByLimit(this.limit)
        return this.getPhotos.slice(0, this.limit)
      }

      return this.getPhotos
    }
  },
  methods: {
    ...mapActions('utils', ['openLightbox']),
    selectImage (key) {
      this.openLightbox(key)

      this.sendEventGA('Gallery', `Image ${key + 1}`, 'Selected')
    }
  }
}
